"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const account_info_1 = __importDefault(require("./account-info"));
const common_1 = __importDefault(require("./common"));
const spaces_1 = __importDefault(require("./spaces"));
const posts_1 = __importDefault(require("./posts"));
const profiles_1 = __importDefault(require("./profiles"));
const reactions_1 = __importDefault(require("./reactions"));
const space_permission_1 = __importDefault(require("./space-permission"));
const roles_1 = __importDefault(require("./roles"));
const faucet_1 = __importDefault(require("./faucet"));
const history_1 = __importDefault(require("./history"));
const moderation_1 = __importDefault(require("./moderation"));
const score_1 = __importDefault(require("./score"));
const system_1 = __importDefault(require("./system"));
const types = [
    account_info_1.default,
    common_1.default,
    spaces_1.default,
    score_1.default,
    system_1.default,
    posts_1.default,
    profiles_1.default,
    reactions_1.default,
    space_permission_1.default,
    roles_1.default,
    faucet_1.default,
    history_1.default,
    moderation_1.default
].flat();
exports.default = {
    types
};
